export enum LicenceCustomerState {
  Without = 'Without',
  Ok = 'Ok',
  Expired = 'Expired'
}
